import { Row } from '../grid';
import Base from '../base';

/* istanbul ignore next */
Row.install = function (Vue) {
  Vue.use(Base);
  Vue.component(Row.name, Row);
};

export default Row;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ant-design-vue@1.7.8@ant-design-vue/es/row/index.js
// module id = null
// module chunks = 